// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3jIkN","label":"CategoryService_label__3qe8y","location":"CategoryService_location__yBKyS"};